import React from 'react';

import './video.scss';

export const Video = ({ src }) => {
  return (
    <span className="bd-video">
      <iframe
        className="bd-video__iframe"
        src={src}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
      />
    </span>
  );
};
